import { WrapperGS, WrapperValued } from '../core/WrapperGS';

export class MeterGS extends WrapperGS<HTMLMeterElement> implements WrapperValued
{
    static ForHTMLElement(el: HTMLElement): boolean {
        return el.nodeName.toLowerCase() === "meter";
    }

    constructor(el: HTMLMeterElement|string)
    {
        super(el);
    }

    public get value() { return this.el.value; }
    public set value(value: number) { this.el.value = value; }

    public get min() { return this.el.min; }
    public set min(value: number) { this.el.min = value; }

    public get max() { return this.el.max; }
    public set max(value: number) { this.el.max = value; }

    public get low() { return this.el.low; }
    public set low(value: number) { this.el.low = value; }

    public get high() { return this.el.high; }
    public set high(value: number) { this.el.high = value; }

    public get optimum() { return this.el.optimum; }
    public set optimum(value: number) { this.el.optimum = value; }

    public get percent() {
        const range = this.max - this.min;
        return range > 0 ? ((this.value - this.min) / range) * 100 : 0;
    }
}
WrapperGS.ExtendComponentsByHTMLElement(MeterGS);
